import { HttpInjector } from '@/cowboy/http/HttpInjector'
import { PrintableRedeemedResponse } from '@/cowboy/printable/object/PrintableRedeemedResponse'
import { LandingPageCustomizationResponse } from '@/cowboy/printable/object/LandingPageCustomizationResponse'

export class PrintableApi extends HttpInjector {
  /**
   * Request to Printable redeem url
   * @param {string} printedCode
   * @param {string} captchaToken
   * @return {Promise<PrintableRedeemedResponse>}
   */
  static async redeem (printedCode, captchaToken) {
    const response = await this.$http.put('/printable/redeem', {
      printedCode,
      captchaToken
    })
    return this.cast(response.data, PrintableRedeemedResponse)
  }

  /**
   * Fetch landing page customizations
   * @param {string} uri
   * @return {Promise<LandingPageCustomizationResponse>}
   */
  static async landingPage (uri) {
    const response = await this.$http.get(`/landingPageCustomizations/${uri}`)
    return this.cast(response.data, LandingPageCustomizationResponse)
  }
}
